const sectionEvents = {
    UpdateQuestions: {
        Name: "SECTION.UPDATEQUESTIONS",
        New(pageID, validatedSection) {
            return {
                type: sectionEvents.UpdateQuestions.Name,
                PageID: pageID,
                SectionID: validatedSection.GUID,
                Questions: validatedSection.Questions
            };
        }
    },
    Saving: {
        Name: "SECTION.SAVING",
        New(pageID, sectionID) {
            return {
                type: sectionEvents.Saving.Name,
                PageID: pageID,
                SectionID: sectionID
            };
        }
    },
    Saved: {
        Name: "SECTION.SAVED",
        New(pageID, sectionID) {
            return {
                type: sectionEvents.Saved.Name,
                PageID: pageID,
                SectionID: sectionID
            };
        }
    },
    SaveErrored: {
        Name: "SECTION.SAVEERRORED",
        New(pageID, sectionID, error) {
            return {
                type: sectionEvents.SaveErrored.Name,
                PageID: pageID,
                SectionID: sectionID,
                Error: error
            }
        }
    },
    ClearErrors: {
        Name: "SECTION.CLEARERRORS",
        New(pageID, sectionID) {
            return {
                type: sectionEvents.SaveErrored.Name,
                PageID: pageID,
                SectionID: sectionID
            }
        }
    }
};

module.exports = sectionEvents;


// WEBPACK FOOTER //
// ./src/events/section/sectionEvents.js